import API_RESPONSE_CODE, { HTTP_STATUS_CODE } from "@constants/api.response.code";

export const ERROR_PAGE_STRINGS = t => ({
  contactUs: t("errorScreens.contactUs"),
  loginAgain: t("errorScreens.loginAgain"),
  refresh: t("errorScreens.refresh"),
});

const FULL_SCREEN_ERROR_STRINGS = t => ({
  [HTTP_STATUS_CODE.UNAUTHORIZED]: {
    title: t("errorScreens.unauthorizedAccessTitle"),
    message: t("errorScreens.unauthorizedAccessMessage"),
  },
  [HTTP_STATUS_CODE.FORBIDDEN]: {
    title: t("errorScreens.accessDeniedTitle"),
    message: t("errorScreens.accessDeniedMessage"),
  },
  [HTTP_STATUS_CODE.SERVICE_UNAVAILABLE]: {
    title: t("errorScreens.maintenanceTitle"),
    message: t("errorScreens.maintenanceMessage"),
  },
  [API_RESPONSE_CODE.APP_CRASH]: {
    title: t("errorScreens.unexpectedErrorTitle"),
    message: t("errorScreens.unexpectedErrorMessage"),
  },
});

export default FULL_SCREEN_ERROR_STRINGS;
